import Button from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import { Icons } from "atoms/constants/icons";
import React, { forwardRef } from "react";
import { t } from "utilities/localization-utils";
import NotebookRecord from "models/view-models/notebook-record";
import useNotebookActionPermission, {
    NotebookAction,
} from "pages/notebooks/use-notebook-action-permissions";

export interface ShareNotebookMenuItemProps {
    notebook: NotebookRecord;
    onClick: () => void;
}

const ShareNotebookMenuItem = forwardRef<
    HTMLButtonElement,
    ShareNotebookMenuItemProps
>((props, ref) => {
    const { notebook, onClick } = props;
    const { can } = useNotebookActionPermission(notebook);

    return (
        can(NotebookAction.Share) && (
            <>
                <Button
                    accessibleText={t("shareItem", {
                        item: t("notebook"),
                    })}
                    cssClassName={"-icon-left"}
                    onClick={onClick}>
                    <Icon type={Icons.Share} />
                    {t("shareNotebook")}
                </Button>
            </>
        )
    );
});

export default ShareNotebookMenuItem;
